'use client';

import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

export interface AppSettings {
  backendUrl: string;
  frontendUrl: string;
  originUrl: string;
  mediaUrl: string;
  googleAuthToken: string;
  useSearch: boolean;
  setUseSearch: (val: boolean) => void;
}

export const AppSettingsContext = createContext<AppSettings>({
  backendUrl: '',
  frontendUrl: '',
  originUrl: '',
  mediaUrl: '',
  googleAuthToken: '',
  useSearch: false,
  setUseSearch: () => {},
});

export const useAppSettings = (): AppSettings => useContext(AppSettingsContext);

export const AppProvider = ({
  children,
  backendUrl,
  originUrl,
  frontendUrl,
  mediaUrl,
  googleAuthToken,
}: PropsWithChildren<Omit<AppSettings, 'useSearch' | 'setUseSearch'>>) => {
  const [useSearch, setUseSearch] = useState(false);

  const config: AppSettings = useMemo(() => {
    return {
      backendUrl,
      originUrl,
      frontendUrl,
      mediaUrl,
      googleAuthToken,
      useSearch,
      setUseSearch,
    };
  }, [
    backendUrl,
    frontendUrl,
    googleAuthToken,
    mediaUrl,
    originUrl,
    useSearch,
    setUseSearch,
  ]);

  return (
    <AppSettingsContext.Provider value={config}>
      {children}
    </AppSettingsContext.Provider>
  );
};
